import styled from 'styled-components'

import { COLOR, FONT_SIZE, NATIVE_BASE_COLORS } from '../../../../themes'

export const StylesRepeatToggle = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16;

  .title {
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.XS};
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
  }

  .radio-layout {
    width: 146px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    input[type='radio'] {
      width: 24px;
      height: 24px;
      accent-color: ${COLOR.BLACK_5};
      cursor: pointer;
      margin: 0;
    }
  }

  .options {
    display: flex;
    align-items: center;
  }

  .option-text {
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[800]};
    margin-left: 8px;
    cursor: pointer;
  }
`
